if (!customElements.get('quick-add-viewer')) {
  class QuickAddViewer extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.trigger = this.dataset.trigger || false;
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();

      if (this.trigger != false) {
        const trigger = document.querySelector(this.trigger);
        if (trigger && trigger.open) trigger.open();
      }
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          const mainGallerySlider = this.productElement.querySelector('[id^="GalleryViewer-"]')
          const submitButton = this.productElement.querySelector('[type="submit"]');
          const galleryThumbnailSlider = this.productElement.querySelector('[data-vertical]')
          if (galleryThumbnailSlider) galleryThumbnailSlider.setAttribute('data-vertical', false)
          if (mainGallerySlider) mainGallerySlider.setAttribute('data-horizontal-on-desktop', true)
          if ((submitButton.classList.contains('add-multiple-times') || submitButton.classList.contains('add-just-once')) && opener.closest('upsell-card')) {
            submitButton.removeAttribute('aria-disabled');
            submitButton.removeAttribute('disabled');
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.adjustGalleryThumbnailsForQuickAdd()
          this.removeCrossSellProducts();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          const cartDrawer = opener.closest('cart-drawer');
          if (cartDrawer) cartDrawer.close();
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variant_selectors = this.modalContent.querySelector('variant-radios,variant-selects')
      if (!variant_selectors) return;
      variant_selectors.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const crossSellItems = this.productElement.querySelectorAll('[data-cross-sell-item]')
      if (crossSellItems) crossSellItems.forEach(item => item.remove());
    }

    preventDuplicatedIDs() {
      const originalSectionId = this.productElement.dataset.originalSection;
      const sectionId = this.productElement.dataset.sectionId;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = originalSectionId;
      });
    }

    adjustGalleryThumbnailsForQuickAdd() {
      const galleryWithThumbnails = this.modalContent.querySelector('.product__media-with-vertical-thumbnails');
      const thumbnailsContainer = this.modalContent.querySelector('.product__media-with-vertical-thumbnail');
      if (galleryWithThumbnails) galleryWithThumbnails.classList.remove('product__media-with-vertical-thumbnails')
      if (thumbnailsContainer) thumbnailsContainer.classList.remove('product__media-with-vertical-thumbnail')
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    removeCrossSellProducts() {
      const crossSellItem = this.modalContent.querySelector('.cross-sell-item');
      if (!crossSellItem) return;
      crossSellItem.remove();
    }
  }

  customElements.define('quick-add-viewer', QuickAddViewer);
}
